import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';

import { AUTH_MANAGER } from '@asset-solutions/customer-portal/auth/data-access';

export const alreadyAuthenticatedGuard: CanActivateFn = () => {
  const user = inject(AUTH_MANAGER).currentUser();
  const router = inject(Router);

  return user ? router.createUrlTree(['']) : true;
};
